import { useMemo } from 'react';
import { DocumentType } from '@sib/api';
import { createUseAppTranslation } from '@sib/i18n';

const useDocumentsTranslation = createUseAppTranslation('documents');

export const useDocumentTypeOptions = () => {
  const { t } = useDocumentsTranslation();

  return useMemo(
    () => [
      {
        label: t('enums.documentType.invoice'),
        value: DocumentType.Invoice,
      },
      {
        label: t('enums.documentType.contract'),
        value: DocumentType.Contract,
      },
      {
        label: t('enums.documentType.letterOfAuthorization'),
        value: DocumentType.LetterOfAuthorization,
      },
      {
        label: t('enums.documentType.siteList'),
        value: DocumentType.SiteList,
      },
      {
        label: t('enums.documentType.other'),
        value: DocumentType.Other,
      },
    ],
    [t]
  );
};
